module.exports = __webpack_public_path__ + "static/media/SX.380560cc.svg";